module.exports = __webpack_public_path__ + "img/menu_bottom_1.eed1e53d.svg";